import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

const initialState = {
  isFetching: false,
  data: {},
  detailData: {},
  isLoggedIn: false,
};

export const noticeboardReducer = createReducer(initialState, {
  [types.NOTICEBOARD_RESPONSE](state, action) {
    return {
      ...state,
      data: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.NOTICEBOARD_DETAIL_RESPONSE](state, action) {
    return {
      ...state,
      detailData: action.response.data,
      errorMessage: action.response.message,
    };
  },
  [types.LOG_OUT]() {
    return {
      ...initialState,
    };
  },
});
